<template>
  <b-card class="history-card">
    <div class="history-header">
      <div>
        <h3>Histórico de Análises</h3>

        <span>
          {{ analyses.length }} propostas encontradas
        </span>
      </div>

      <div class="history-actions">
        <b-button
          class="filter-button"
          @click="$emit('filter')"
        >
          <feather-icon
            icon="FilterIcon"
            size="17"
          />
        </b-button>

        <b-button
          class="new-analysis-button"
          @click="$emit('new-analysis')"
        >
          + Nova Pré-Análise
        </b-button>
      </div>
    </div>

    <div class="analysis-list">
      <div
        v-if="!analyses.length"
        class="empty-state"
      >
        <feather-icon
          icon="FileTextIcon"
          size="42"
          class="empty-state-icon"
        />

        <span class="empty-state-title">
          Nenhuma análise encontrada
        </span>

      </div>

      <analysis-history-item
        v-for="analysis in analyses"
        v-else
        :key="analysis.id"
        :analysis="analysis"
        :downloading-analysis-id="downloadingAnalysisId"
        @view="$emit('view', $event)"
        @start-analysis="$emit('start-analysis', $event)"
        @download="$emit('download', $event)"
        @history="$emit('history', $event)"
      />
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import AnalysisHistoryItem from '../CreditAnalysis/AnalysisHistoryItem.vue'

export default {
  name: 'AnalysisHistory',

  components: {
    BCard,
    BButton,
    AnalysisHistoryItem
  },

  props: {
    analyses: {
      type: Array,
      default: () => []
    },
    downloadingAnalysisId: {
      type: [Number, String],
      default: null
    }
  }
}
</script>

<style scoped>
.history-card {
  border: 0;
  border-radius: 8px;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.history-header h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.history-header span {
  font-size: 12px;
}

.history-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}
.filter-button {
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent !important;
  border: none !important;
  color: #6e6b7b !important;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
}

.filter-button:hover,
.filter-button:focus,
.filter-button:active {
  background: transparent !important;
  border: none !important;
  color: #a63d4b !important;
  box-shadow: none !important;
}

.new-analysis-button {
  height: 38px;
  min-width: 170px;
  padding: 6px 12px;
  background: #a63d4b;
  border-color: #a63d4b;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.analysis-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  border-radius: 8px;
  padding: 8px;
  max-height: 480px;
  overflow-y: auto;
}
.empty-state {
  grid-column: 1 / -1;
  width: 100%;
  min-height: 260px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
}
.analysis-list::-webkit-scrollbar {
  width: 10px;
}

.analysis-list::-webkit-scrollbar-thumb {
  background: #858585;
  border-radius: 10px;
  
}

@media (max-width: 768px) {
  .history-header {
    align-items: flex-start;
    gap: 10px;
  }

  .history-actions {
    flex-direction: column;
  }

  .new-analysis-button {
    min-width: auto;
  }

  .analysis-list {
    padding: 12px;
  }
}
.dark-layout::-webkit-scrollbar {
  width: 7px;
}

.dark-layout::-webkit-scrollbar-track {
  background: transparent;
  border: none;
}

.dark-layout::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  border: none;
}

.dark-layout::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.55);
}
</style>